import { graphql } from '@api/generated';
import { useQuery } from '@apollo/client';

export const getCustomerByIdQuery = graphql(`
  query getCustomerById(
    $tenantId: ID!
    $customerId: ID!
    $includeCustomerInformation: Boolean!
  ) {
    customer(tenantId: $tenantId, id: $customerId) {
      id
      name
      contacts {
        id
        type
        value
        memo
        jobRemindersEnabled
        marketingUpdatesEnabled
        invoiceStatementNotification
      }
      locations {
        id
        active
        name
        address {
          street
          unit
          city
          state
          zip
          country
        }
      }
      tags {
        name
        color
      }
      doNotService
      ... @include(if: $includeCustomerInformation) {
        type
        lifetimeRevenue
        outstandingBalance
        membership
      }
    }
  }
`);

const useGetCustomerById = (
  tenantId: string,
  customerId?: string,
  includeCustomerInformation: boolean = false,
) => {
  const skip = !customerId;
  const { data, loading, error, refetch } = useQuery(getCustomerByIdQuery, {
    fetchPolicy: 'network-only',
    variables: skip
      ? undefined
      : { tenantId, customerId, includeCustomerInformation },
    notifyOnNetworkStatusChange: true,
    skip,
  });

  const customer = data?.customer;

  return { customer, loading, error, refetch };
};

export default useGetCustomerById;
